export class ScreenId {
  // ログイン
  static SF0001 = "SF0001";
  // トップ
  static SF0101 = "SF0101";
  // メニュー
  static SF0102 = "SF0102";
  // 災害名称一覧（参照）
  static SF0201 = "SF0201";
  // 災害名称編集
  static SF0202 = "SF0202";
  // 災害名称登録
  static SF0203 = "SF0203";
  // 災害名称参照
  static SF0204 = "SF0204";
  // 災害名称一覧（登録・編集・削除）
  static SF0205 = "SF0205";
  // OIL一覧
  static SF2001 = "SF2001";
  // 住民向け広報一覧（参照）
  static SF0301 = "SF0301";
  // 住民向け広報一覧（登録・編集・削除）
  static SF0302 = "SF0302";
  // 住民向け広報参照（プッシュ通知）
  static SF0303 = "SF0303";
  // 住民向け広報編集（プッシュ通知）
  static SF0304 = "SF0304";
  // 住民向け広報登録（プッシュ通知）
  static SF0305 = "SF0305";
  // 住民向け広報参照（緊急速報メール）
  static SF0306 = "SF0306";
  // 住民向け広報登録・編集（緊急速報メール）
  static SF0308 = "SF0308";
  // クロノロジー情報一覧（参照）
  static SF0402 = "SF0402";
  // クロノロジー情報編集
  static SF0403 = "SF0403";
  // クロノロジー情報登録
  static SF0404 = "SF0404";
  // クロノロジー情報詳細
  static SF0405 = "SF0405";
  // クロノロジー情報一覧（登録・編集・削除）
  static SF0406 = "SF0406";
  // 要配慮者施設ＱＲコード発行単位登録
  static SF0601 = "SF0601";
  // 要配慮者施設ＱＲコード登録
  static SF0602 = "SF0602";
  // 要配慮者施設ＱＲコード発行者一覧
  static SF0603 = "SF0603";
  // 学校ＱＲコード発行単位登録
  static SF0604 = "SF0604";
  // 学校ＱＲコード登録
  static SF0605 = "SF0605";
  // 学校ＱＲコード発行者一覧
  static SF0606 = "SF0606";
  // 仮ＱＲコード発行単位登録
  static SF0607 = "SF0607";
  // 仮ＱＲコード登録
  static SF0608 = "SF0608";
  // 仮ＱＲコード発行者一覧
  static SF0609 = "SF0609";
  // バスＱＲコード印刷
  static SF0610 = "SF0610";
  // 安定ヨウ素剤配布状況一覧
  static SF1001 = "SF1001";
  // 安定ヨウ素剤事前配布状況個人検索
  static SF1002 = "SF1002";
  // ユーザ情報一覧（参照）
  static SF1201 = "SF1201";
  // ユーザ情報登録
  static SF1202 = "SF1202";
  // ユーザ情報編集
  static SF1203 = "SF1203";
  // 操作権限付与一覧（参照）
  static SF1204 = "SF1204";
  // 操作権グループ新規登録
  static SF1205 = "SF1205";
  // 操作権グループ名称編集
  static SF1206 = "SF1206";
  // ユーザ情報一覧（登録・編集・削除）
  static SF1207 = "SF1207";
  // 操作権限付与一覧（登録・編集・削除）
  static SF1208 = "SF1208";
  // 避難所状況一覧
  static SF1301 = "SF1301";
  // 避難者検索一覧
  static SF1303 = "SF1303";
  // 原子力災害関係施設マスタ一覧（参照）
  static SF1401 = "SF1401";
  // 原子力災害関係施設マスタ一覧（登録・編集・削除）
  static SF1402 = "SF1402";
  // 原子力災害関係施設マスタ編集
  static SF1403 = "SF1403";
  // 原子力災害関係施設マスタ詳細
  static SF1404 = "SF1404";
  // 原子力災害関係施設状況一覧（参照）
  static SF1405 = "SF1405";
  // 原子力災害関係施設状況一覧（編集）
  static SF1406 = "SF1406";
  // 原子力災害関係施設状況編集
  static SF1407 = "SF1407";
  // 原子力災害関係施設状況詳細
  static SF1408 = "SF1408";
  // 要配慮者施設マスタ一覧（参照）
  static SF1501 = "SF1501";
  // 要配慮者施設マスタ一覧（登録・編集・削除）
  static SF1502 = "SF1502";
  // 要配慮者施設マスタ編集
  static SF1503 = "SF1503";
  // 要配慮者施設マスタ詳細
  static SF1504 = "SF1504";
  // 要配慮者施設状況一覧（参照）
  static SF1505 = "SF1505";
  // 要配慮者施設状況一覧（編集）
  static SF1506 = "SF1506";
  // 要配慮者施設状況編集
  static SF1507 = "SF1507";
  // 要配慮者施設状況詳細
  static SF1508 = "SF1508";
  // 管理車両一覧
  static SF1701 = "SF1701";
  // 管理車両登録
  static SF1702 = "SF1702";
  // 管理車両編集
  static SF1703 = "SF1703";
  // 搭載資機材登録
  static SF1704 = "SF1704";
  // 搭載資機材編集
  static SF1705 = "SF1705";
  // 車両事業者一覧
  static SF1706 = "SF1706";
  // 車両事業者登録
  static SF1707 = "SF1707";
  // 車両事業者編集
  static SF1708 = "SF1708";
  // 防災関係者向け広報一覧
  static SF1801 = "SF1801";
  // 防災関係者向け広報参照
  static SF1802 = "SF1802";
  // 防災関係者向け広報登録・編集
  static SF1803 = "SF1803";
  // 避難車両配車システム表示
  static SF1901 = "SF1901";
  // 防災資機材の配備状況取込
  static SF1902 = "SF1902";
  // 安定ヨウ素剤の事前配布状況取込
  static SF1903 = "SF1903";
  // 避難退域時検査場所状況表示
  static SF1904 = "SF1904";
  // 災害配信定型文マスタ一覧（参照）
  static SF3001 = "SF3001";
  // 災害配信定型文マスタ一覧（登録・編集・削除）
  static SF3002 = "SF3002";
  // 情報ガイドマスタ一覧（参照）
  static SF3101 = "SF3101";
  // 情報ガイドマスタ一覧（登録・編集・削除）
  static SF3102 = "SF3102";
  // 地図表示
  static SF9001 = "SF9001";
  // Lアラート一覧（参照・登録）
  static SF2101 = "SF2101";
  // Lアラート参照（お知らせ）
  static SF2102 = "SF2102";
  // Lアラート登録・編集（お知らせ）
  static SF2103 = "SF2103";
  // Lアラート参照（避難情報）
  static SF2104 = "SF2104";
  // Lアラート登録・編集（避難情報）
  static SF2105 = "SF2105";
  // 自治会マスタ一覧（参照）
  static SF4001 = "SF4001";
  // 自治会マスタ一覧（登録・編集・削除）
  static SF4002 = "SF4002";
  // 自治会マスタ編集
  static SF4003 = "SF4003";
  // 自治会マスタ詳細
  static SF4004 = "SF4004";
  // 自治会マスタ登録
  static SF4005 = "SF4005";
  // 調整システム
  static SF4101 = "SF4101";
  // モニタリングポスト一覧
  static SF4102 = "SF4102";
  // 避難元避難先（避難所）
  static SF4103 = "SF4103";
  // 避難元避難先（医療機関等）
  static SF4104 = "SF4104";
  // 受入市町の被災状況確認（自治会）
  static SF4201 = "SF4201";
  // 避難対象の自治会確認
  static SF4202 = "SF4202";
  // 代替避難所の仮登録
  static SF4203 = "SF4203";
  // 代替避難所の確定
  static SF4204 = "SF4204";
  // 避難対象の医療機関等確認
  static SF4205 = "SF4205";
  // 代替医療機関等の仮登録
  static SF4206 = "SF4206";
  // 代替医療機関等の確定
  static SF4207 = "SF4207";

  static SCREEN_TITLE_LIST = {
    SF0201: "災害名称一覧（参照）",
    SF0205: "災害名称一覧（登録・編集・削除）",
    SF2001: "OIL一覧",
    SF0301: "住民向け広報一覧（参照）",
    SF0302: "住民向け広報一覧（登録・編集・削除）",
    SF0303: "住民向け広報参照（プッシュ通知）",
    SF0304: "住民向け広報編集（プッシュ通知）",
    SF0305: "住民向け広報登録（プッシュ通知）",
    SF0306: "住民向け広報参照（緊急速報メール）",
    SF0308: "住民向け広報登録・編集（緊急速報メール）",
    SF0402: "クロノロジー情報一覧（参照）",
    SF0406: "クロノロジー情報一覧（登録・編集・削除）",
    SF0601: "要配慮者施設ＱＲコード発行単位登録",
    SF0602: "要配慮者施設ＱＲコード登録",
    SF0603: "要配慮者施設ＱＲコード発行対象一覧",
    SF0604: "学校ＱＲコード発行単位登録",
    SF0605: "学校ＱＲコード登録",
    SF0606: "学校ＱＲコード発行対象一覧",
    SF0607: "仮ＱＲコード発行単位登録",
    SF0608: "仮ＱＲコード登録",
    SF0609: "仮ＱＲコード発行対象一覧",
    SF0610: "バスＱＲコード印刷",
    SF1001: "安定ヨウ素剤配布状況一覧",
    SF1002: "安定ヨウ素剤事前配布状況個人検索",
    SF1201: "ユーザ情報一覧（参照）",
    SF1204: "操作権限付与一覧（参照）",
    SF1207: "ユーザ情報一覧（登録・編集・削除）",
    SF1208: "操作権限付与一覧（登録・編集・削除）",
    SF1301: "避難所状況一覧",
    SF1303: "避難者検索",
    SF1401: "原子力災害関係施設マスタ一覧（参照）",
    SF1402: "原子力災害関係施設マスタ一覧（登録・編集・削除）",
    SF1405: "原子力災害関係施設状況一覧（参照）",
    SF1406: "原子力災害関係施設状況一覧（編集）",
    SF1501: "要配慮者施設マスタ一覧（参照）",
    SF1502: "要配慮者施設マスタ一覧（登録・編集・削除）",
    SF1505: "要配慮者施設状況一覧（参照）",
    SF1506: "要配慮者施設状況一覧（編集）",
    SF1701: "管理車両一覧",
    SF1801: "防災関係者向け広報一覧",
    SF1802: "防災関係者向け広報参照",
    SF1803: "防災関係者向け広報登録・編集",
    SF1901: "避難車両配車システム表示",
    SF1902: "防災資機材の配備状況取込",
    SF1903: "安定ヨウ素剤の事前配布状況取込",
    SF1904: "避難退域時検査場所状況表示",
    SF3001: "災害配信定型文マスタ一覧（参照）",
    SF3002: "災害配信定型文マスタ一覧（登録・編集・削除）",
    SF3101: "情報ガイドマスタ一覧（参照）",
    SF3102: "情報ガイドマスタ一覧（登録・編集・削除）",
    SF2101: "Lアラート一覧",
    SF2102: "Lアラート参照（お知らせ）",
    SF2103: "Lアラート登録・編集（お知らせ）",
    SF2104: "Lアラート参照（避難情報）",
    SF2105: "Lアラート登録・編集（避難情報）",
    SF4001: "自治会マスタ一覧（参照）",
    SF4002: "自治会マスタ一覧（登録・編集・削除）",
    SF4101: "調整システム表示",
    SF4102: "モニタリングポスト一覧",
    SF4103: "避難元避難先（避難所）",
    SF4104: "避難元避難先（医療機関等）",
    SF4201: "受入市町の被災状況確認（自治会）",
    SF4202: "避難対象の自治会確認",
    SF4203: "代替避難所の仮登録",
    SF4204: "代替避難所の確定",
    SF4205: "避難対象の医療機関等確認",
    SF4206: "代替医療機関等の仮登録",
    SF4207: "代替医療機関等の確定"
  };

  static OPERATION_LIST = [
    ScreenId.SF0205, // 災害名称登録・編集・削除
    ScreenId.SF2001,
    ScreenId.SF0302, // 住民向け広報登録・編集・削除
    ScreenId.SF0308, // 住民向け広報登録・編集・削除
    ScreenId.SF0406, // クロノロジー情報登録・編集・削除
    ScreenId.SF0601, // 要配慮者施設QRコード発行単位登録
    ScreenId.SF0602, // 要配慮者施設QRコード登録
    ScreenId.SF0603, // 要配慮者施設QRコード発行者一覧
    ScreenId.SF0604, // 学校ＱＲコード発行単位登録
    ScreenId.SF0605, // 学校ＱＲコード登録
    ScreenId.SF0606, // 学校ＱＲコード発行対象一覧
    ScreenId.SF0607, // 仮ＱＲコード発行単位登録
    ScreenId.SF0608, // 仮ＱＲコード登録
    ScreenId.SF0609, // 仮ＱＲコード発行対象一覧
    ScreenId.SF0610, // バスQRコード印刷
    ScreenId.SF1207, // ユーザ情報登録・編集・削除
    ScreenId.SF1208, // 権限付与登録・編集
    // ScreenId.SF1403, // 原子力災害関係施設マスタ編集
    // ScreenId.SF1407, // 原子力災害関係施設状況編集
    // ScreenId.SF1503, // 要配慮者施設マスタ編集
    // ScreenId.SF1507, // 要配慮者施設状況編集
    ScreenId.SF1402,
    ScreenId.SF1406,
    ScreenId.SF1502,
    ScreenId.SF1506,
    ScreenId.SF1701,
    ScreenId.SF1801,
    ScreenId.SF1902,
    ScreenId.SF1903,
    ScreenId.SF3002,
    ScreenId.SF3102,
    ScreenId.SF2101, // Lアラート一覧
    ScreenId.SF2102, // Lアラート参照（お知らせ）
    ScreenId.SF2103, // Lアラート登録・編集（お知らせ）
    ScreenId.SF2104, // Lアラート参照（避難情報）
    ScreenId.SF2105, // Lアラート登録・編集（避難情報）
    ScreenId.SF4002 // 自治会マスタ一覧（登録・編集・削除）
  ];

  constructor(value) {
    this.value = value;
  }

  static getScreenTitle(value) {
    return ScreenId.SCREEN_TITLE_LIST[value];
  }

  static factory(value) {
    return new ScreenId(value);
  }

  isOperation() {
    return ScreenId.OPERATION_LIST.some(screenId => screenId === this.value);
  }
}
